import { render, staticRenderFns } from "./SwapsSell.vue?vue&type=template&id=3e4e9fc2"
import script from "./SwapsSell.vue?vue&type=script&lang=ts"
export * from "./SwapsSell.vue?vue&type=script&lang=ts"
import style0 from "./SwapsSell.vue?vue&type=style&index=0&id=3e4e9fc2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports